import {
    OBTENER_APLICATIONS,
    OBTENER_DEVICE_PROFILES,
    OBTENER_DEVICE_PROFILE 
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_APLICATIONS:
            return {
                ...state,
                aplications: action.payload
            }
        case OBTENER_DEVICE_PROFILES:
            return {
                ...state,
                deviceProfiles: action.payload
            }
        case OBTENER_DEVICE_PROFILE:
            return {
                ...state,
                deviceProfile: action.payload
            }        
        default:
            return state;
    }
}